// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bruteforcesettings-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-clds-yO2_mjs":"bc681b12376e8eca3232","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-ClzJbciL_mjs":"f7bb63043e44bcbbcf00"}[chunkId] + "";
};